export const socialsData = {
  github: "https://github.com/lino-silva",
  linkedIn: "https://www.linkedin.com/in/linosilva/",
  stackOverflow: "https://stackoverflow.com/users/717007/lino-silva",
  mastodon: "https://social.lino.cooking/@lino",
  twitch: "https://www.twitch.tv/linosilva",
  printables: "https://www.printables.com/@linosilva_87854",
};
